<template>
  <div class="asc-flight-deck-effects">
    <div class="asc-flight-deck-effects--details">
      <asc-icon
        class="asc-flight-deck-effects--icon"
        icon="wifiStrengthOff"
        :color="getStatusColor"
        :size="17"
      ></asc-icon>
      {{ getIntroText }}
    </div>
    <asc-legend :items="getLegendItems"></asc-legend>
  </div>
</template>

<script>
import AscIcon from '@/components/atoms/AscIcon'
import AscLegend from '@/components/molecules/AscLegend'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscConnectivity',

  components: {
    AscIcon,
    AscLegend,
  },

  props: {
    days: {
      type: Number,
      default: 0,
    },
    tailNumber: {
      type: String,
      default: '',
    },
  },

  computed: {
    getIntroText() {
      return `${this.tailNumber} has a Connection Status of '${this.getStatus}'. It has been ${this.days} days since data was last received.`
    },

    getStatus() {
      if (this.days < 3) {
        return 'NORMAL'
      }

      return this.days >= 7 ? 'WARNING' : 'CAUTION'
    },

    getStatusColor() {
      if (this.days < 3) {
        return variables.gray500
      }

      return this.days >= 7 ? variables.warningbase : variables.cautionbase
    },

    getLegendItems() {
      return [
        {
          text: 'CAUTION: BETWEEN 3-6 DAYS SINCE LAST CONNECTION',
          styleColor: variables.cautionbase,
          icon: 'wifiStrengthOff',
        },
        {
          text: 'WARNING: 7 OR MORE DAYS SINCE LAST CONNECTION',
          styleColor: variables.warningbase,
          icon: 'wifiStrengthOff',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.asc-flight-deck-effects {
  &--details {
    display: flex;
    margin-bottom: 24px;
  }

  &--icon {
    margin-right: 12px;
  }
}
</style>
